import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvelopeEditTabs } from '../enum/envelope-edit-tabs';
import { EnvelopeEditService } from '../envelope/services/envelope-edit.service';
import { SignatureStatus } from '../enum/signature-status';

const CONTROLLER = 'envelopeFileRejected';
@Injectable({
  providedIn: 'root',
})
export class DocumentRejectedService {

  constructor(
    private http: HttpClient,
    private envelopeEditService: EnvelopeEditService
  ) { }

  private documentsForRejectedSource = new BehaviorSubject<any>(null);
  private isDocumentRejectedSource = new BehaviorSubject<any>(null);

  documentsForRejected$ = this.documentsForRejectedSource.asObservable();
  isDocumentRejected$ = this.isDocumentRejectedSource.asObservable();

  setDocumentsForRejected(value: any) {
    this.documentsForRejectedSource.next(value);
  }

  setIsRemoveDocumentRejected(value: any) {
    this.isDocumentRejectedSource.next(value);
  }

  public envelopeRejected(body: any): Observable<any> {
    return this.http.post(CONTROLLER, body);
  }

  verifyIsRemoveDocumentRejected(signatories: any[]) {
    this.isDocumentRejected$.subscribe((data) => {
      if (data !== null) {
        const files = this.envelopeEditService.getModelData(
          EnvelopeEditTabs.Information
        ).value.files;

        const filesOriginal = this.envelopeEditService.getModelData(
          EnvelopeEditTabs.Information
        ).value.filesOriginal;

        const allFilesWithoutRejection = files.every(
          file => file.envelopeRejectedHistory.length === 0
        );

        const anyRejectedFile = files.some(
          file => file.envelopeRejectedHistory.length > 0
        );

        if (allFilesWithoutRejection) {
          signatories.forEach(signatory => {
            if (signatory.status === SignatureStatus.Declined) {
              signatory.status = SignatureStatus.Signed;
            }
          });
        }

        if (anyRejectedFile) {
          filesOriginal.forEach(fileOriginal => {
            if (fileOriginal.envelopeRejectedHistory.length > 0) {
              const rejectedHistory = fileOriginal.envelopeRejectedHistory[0];
              const rejectedSignatoryId = rejectedHistory.envelopeSignatoryId;

              signatories.forEach(signatory => {
                if (
                  signatory.status === SignatureStatus.Signed &&
                  signatory.envelopeSignatoryId === rejectedSignatoryId
                ) {
                  signatory.status = SignatureStatus.Declined;
                }
              });
            }
          });
        }
      }
    });
  }
}
